// extracted by mini-css-extract-plugin
export default {"header":"_fd89ad18"};